import styled from "styled-components";

import { theme } from "../../themes/themes";
export const FrameContainer = styled.div`
  width: 100%;
  height: 296px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: flex-start;
  margin: 32px 0;
`;
export const Label = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 11px;
  .MuiSvgIcon-root {
    font-size: 16px;
    margin-left: 15px;
  }
  image {
    width: 400px;
    height: 216px;
    flex-shrink: 0;
    border-radius: 8px;
    background: rgba(53, 4, 77, 0.7);
  }
`;
export const LabelText = styled.div`
  text-align: left;
  color: black;

  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;

  a {
    text-decoration: none;
    color: black;
  }
`;
export const Yammer = styled.div`
  width: 400px;
  height: 216px;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(53, 4, 77, 0.7);
`;
export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
  overflow-x: auto;
`;
export const CardView = styled.div`
  width: 281px;
  height: 216px;
  flex-shrink: 0;
  margin-right: 1.5em;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.text.disabled};
  background: ${({ theme }) => theme.neutral.white};
  margin-bottom: 10px;
  padding: 10px;
  position: relative;
  img {
    width: 100%;
    height: 79px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    position: absolute;
    top: 0px;
    left: 0px;
  }
`;
export const Button = styled.div`
  color: ${({ theme }) => theme.background.light};
  text-align: center;
  font-family: "Noto Sans", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const EmptyCard = styled.div`
  width: 1339px;
  height: 296px;
  background: ${({ theme }) => theme.neutral.white};
  .carditem {
    width: 257px;
    height: 216px;
    fill: ${({ theme }) => theme.background.tertiary};
  }
`;
